import graphOptions from "../variables/graph-options";
import GraphDummyData from "../variables/graph-dummy-data";
import {Line} from "react-chartjs-2";
import {Chart, registerables} from 'chart.js';

Chart.register(...registerables);

export default function LineGraph({className, graphData, loading, ...props}) {

    function formatData() {
        let data = {...GraphDummyData};
        data.labels = graphData?.questionNumber;
        data.datasets[0].data = graphData?.average;
        data.datasets[1].data = graphData?.scores;
        return data;
    }

    if (loading) {
        return <div className={"h-[341px] bg-gray-200 rounded-md animate-pulse animate w-full flex justify-center items-center"}>
            Loading...
        </div>
    }


    return (
        <div className={"h-[341px] w-full graph"}>
            <Line
                options={graphOptions}
                data={formatData()}/>
        </div>

    )
}